// Kind badges: compact, rectangular, one solid colour per kind (principal and trust config kinds, grantee kind,
// audit actor kind). White text on every colour meets WCAG AA (4.5:1 or more) in light and dark themes.

/** Colour of each known kind. Any other kind is neutral grey. */
export const BADGE_TONES: Readonly<Record<string, "blue" | "teal" | "amber" | "violet">> = {
  oidc: "blue",
  spiffe: "teal",
  api_key: "amber",
  principal: "violet",
};

export type BadgeTone = "blue" | "teal" | "amber" | "violet" | "neutral";

export function badgeTone(kind: string): BadgeTone {
  return Object.hasOwn(BADGE_TONES, kind) ? BADGE_TONES[kind] : "neutral";
}

/** One kind badge, for example `<Badge kind="oidc" />`. */
export function Badge({ kind }: { kind: string }) {
  return (
    <span className={`badge badge-${badgeTone(kind)}`} data-kind={kind}>
      {kind}
    </span>
  );
}
